<template>
  <section id="homeTestimonials">
    <div class="container">
      <div class="slide" v-for="(testimonial, index) in shuffledTestimonials" :class="isActiveSlide(index) ? 'active' : ''">
        <div class="circleHeader">
          <h2>
            <span>The Longest Shortest Time is a parenting show for everyone.</span>
            <span>{{ testimonial.first_name }} likes it...</span>
          </h2>
        </div>
        <div class="testimonial">
          <div v-html="testimonial.quote"></div>
          <p class="attribution"><em>—{{ testimonial.attribution }}</em></p>
          <div>
            <button @click="nextTestimonial" v-if="testimonials.length > 1">
              <span>More Praise</span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="4262.82 9804.78 34.581 48.995" width="35" height="49">
                <path d="M-19.71,54.92,11,32.33a2,2,0,0,0,0-3.14L-19.71,6.6a2,2,0,0,0-2.013-.123,2,2,0,0,0-1.1,1.693V53.35a2,2,0,0,0,1.1,1.693A2,2,0,0,0-19.71,54.92Z" transform="translate(4285.64 9798.518)"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'testimonials',
  data () {
    return {
      activeSlide: 0
    }
  },
  methods: {
    isActiveSlide (i) {
      return i === this.activeSlide
    },
    nextTestimonial () {
      if ((this.activeSlide + 1) >= this.testimonials.length) {
        this.activeSlide = 0
      } else {
        this.activeSlide++
      }
    },
    shuffle (array) {
      let i = 0
      let j = 0
      let temp = null

      for (i = array.length - 1; i > 0; i -= 1) {
        j = Math.floor(Math.random() * (i + 1))
        temp = array[i]
        array[i] = array[j]
        array[j] = temp
      }
      return array
    }
  },
  computed: {
    currentTestimonial () {
      if (this.shuffledTestimonials) return this.shuffledTestimonials[this.activeSlide]
    },
    shuffledTestimonials () {
      if (this.testimonials) return this.shuffle(this.testimonials)
    },
    ...mapGetters([
      'testimonials'
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
  @import ../../assets/styles/colors
  @import ../../assets/styles/mixins

  section
    background-color: $yellow
    padding: 30px 30px 0
    position: relative
    +tablet
      padding: 50px 30px 0
    +desktop
      padding: 50px 0 0
    .container
      position: relative
    .slide
      &.active
        position: relative
        z-index: 3
        transition: position 0ms linear 250ms, opacity 250ms
      &:not(.active)
        position: absolute
        opacity: 0
        top: 0
        left: 0
      +desktop
        display: flex
    .circleHeader
      align-items: flex-start
      flex: 1
      &:before
        background-color: #fff
      h2
        margin-top: 20px
        span
          display: block
          &:not(:last-child)
            margin-bottom: 34px

    .testimonial
      background: #fff
      padding: 30px 30px 40px
      border-radius: 28px 28px 0 0
      margin-top: 30px
      position: relative
      +desktop
        padding: 60px 60px 80px
        width: 706px
        min-height: 600px
        margin-left: 80px
        margin-top: 0
      button
        display: flex
        background: transparent
        margin-right: 0
        margin-left: auto
        cursor: pointer
        &:hover
          color: lighten($textColor, 25%)
        +tablet
          bottom: 80px
          right: 60px
        span
          font-weight: bold
          font-size: 18px
          line-height: 29px
          +tablet
            letter-spacing: 0.25px
            font-size: 21px
            line-height: 49px
        svg
          display: block
          margin-left: 25px
          +until($tablet)
            width: 20px
            height: 29px
            margin-left: 18px
          path
            fill: $yellow
</style>

<style lang="sass">
@import ../../assets/styles/mixins

#homeTestimonials
  .testimonial
    p
      +tablet
        font-size: 22px
        line-height: 40px
        margin-bottom: 40px
</style>



// WEBPACK FOOTER //
// Testimonials.vue?3dc29012